module.exports = __webpack_public_path__ + "media/images/official/voice_ohori-4f7abe2b25200cb0281e4a0b3e82110b.png";